export default {
  account: {
    login: '/account/login',
    loginSms: '/account/login/sms',
    register: '/account/register',
    registerPhone: '/account/register/phone',
    adminUsers: '/account/admin/users',
    logout: '/account/logout',
    passwordReset: '/account/password/reset',
    passwordChange: '/account/password/change',
  },
  verification: {
    capabilities: '/verification/capabilities',
    send: '/verification/send',
    check: '/verification/check',
  },
  user: {
    query: '/account/admin/users/{userId}',
    queryUsers: '/account/admin/users',
    update: '/account/admin/users/update',
    delete: '/account/admin/users/delete',
    changeState: '/account/admin/users/status',
    resetPassword: '/account/admin/users/reset-password',
    getUserRoles: '/account/admin/users/{userId}/roles',
    assignRoles: '/account/admin/users/roles',
    oauthBindings: '/account/oauth-bindings',
    bindWechat: '/account/wechat/bind',
    unbindWechat: '/account/wechat/unbind',
  },
  role: {
    list: '/role/list',
    all: '/role/all',
    getById: '/role',
    add: '/role/add',
    update: '/role/update',
    delete: '/role/delete',
    deleteBatch: '/role/deleteBatch',
    assignPermissions: '/role/assignPermissions',
    assignMenus: '/role/assignMenus',
    changeStatus: '/role/changeStatus',
  },
  permission: {
    list: '/permission/list',
    tree: '/permission/tree',
    all: '/permission/all',
    getById: '/permission',
    add: '/permission/add',
    update: '/permission/update',
    delete: '/permission/delete',
    deleteBatch: '/permission/deleteBatch',
  },
  menu: {
    list: '/menu/list',
    tree: '/menu/tree',
    userMenuTree: '/menu/userMenuTree',
    all: '/menu/all',
    getById: '/menu',
    add: '/menu/add',
    update: '/menu/update',
    delete: '/menu/delete',
    deleteBatch: '/menu/deleteBatch',
  },
  device: {
    add: '/device/add',
    query: '/device/query',
    update: '/device/update',
    delete: '/device/delete',
    export: '/device/export',
  },
  agent: {
    add: '/agent/add',
    query: '/agent/query',
    update: '/agent/update',
    delete: '/agent/delete',
  },
  template: {
    query: '/template/query',
    add: '/template/add',
    update: '/template/update',
  },
  message: {
    query: '/message/query',
    update: '/message/update',
    delete: '/message/delete',
    export: '/message/export',
  },
  config: {
    add: '/config/add',
    query: '/config/query',
    update: '/config/update',
    getModels: '/config/getModels',
  },
  robot: {
    query: '/robots/query',
    getById: '/robots',
    create: '/robots',
    update: '/robots',
    delete: '/robots',
    bindAgent: '/robots/{robotId}/agents',
    updateAgent: '/robots/{robotId}/agents/{linkId}',
    removeAgent: '/robots/{robotId}/agents/{agentId}',
    listAgents: '/robots/{robotId}/agents',
    setPrimaryAgent: '/robots/{robotId}/primary-agent',
    bindDevice: '/robots/{robotId}/devices',
    unbindDevice: '/robots/{robotId}/devices/{linkId}',
    listDevices: '/robots/{robotId}/devices',
    addWorkflow: '/robots/{robotId}/workflows',
    updateWorkflow: '/robots/{robotId}/workflows/{linkId}',
    deleteWorkflow: '/robots/{robotId}/workflows/{linkId}',
    listWorkflows: '/robots/{robotId}/workflows',
  },
  memory: {
    query: '/memory/query',
    recent: '/memory/recent',
    search: '/memory/search',
    clear: '/memory/clear',
    cleanup: '/memory/cleanup',
    save: '/memory/save',
    importance: '/memory/importance',
    stats: '/memory/stats',
  },
  voice: {
    list: '/robots/{robotId}/voices',
    addPreset: '/robots/{robotId}/voices/preset',
    createCloned: '/robots/{robotId}/voices/clone',
    listPresets: '/robots/{robotId}/voices/presets',
    update: '/robots/{robotId}/voices/{voiceConfigId}',
    delete: '/robots/{robotId}/voices/{voiceConfigId}',
    switchVoice: '/robots/{robotId}/voices/{voiceConfigId}/switch',
    getCurrent: '/robots/{robotId}/voices/current',
    getCloneStatus: '/robots/{robotId}/voices/{voiceConfigId}/clone-status',
    getSwitchLogs: '/robots/{robotId}/voices/switch-logs',
  },
  upload: '/file/upload',
  livekit: {
    createRoom: '/livekit/room',
    getRoom: '/livekit/room/{roomName}',
    closeRoom: '/livekit/room/{roomName}',
    generateToken: '/livekit/token',
    addAi: '/livekit/room/{roomName}/ai',
    removeAi: '/livekit/room/{roomName}/ai',
    inviteAiAgent: '/livekit/room/{roomName}/ai-agent',
    removeAiAgent: '/livekit/room/{roomName}/ai-agent',
    startRecording: '/livekit/room/{roomName}/recording/start',
    stopRecording: '/livekit/room/{roomName}/recording/stop',
    listUserRooms: '/livekit/rooms/user/{userId}',
  },
}
